'use client';
import { useEffect } from 'react';

export const usePageShowObserver = (props: any) => {
  const { callback } = props;

  useEffect(() => {
    // 监听页面返回事件，若从 bfcache 返回，则调用 callback，主要用于购物车数量刷新
    const pageShowListener = (event: any) => {
      if (event.persisted) {
        callback && callback();
      }
    };
    window.addEventListener('pageshow', pageShowListener);
    return () => {
      window.removeEventListener('pageshow', pageShowListener);
    };
  }, []);
};
